<template>
  <div>
    <div class="timeline-container">
      <PostFrame />
    </div>
    <Footer />
  </div>
</template>

<script>
import PostFrame from "@/components/PostFrame.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "TimeLine",
  components: {
    PostFrame,
    Footer
  }
};
</script>

<style lang="scss">
.timeline-container {
  margin-top: 130px;
  margin-bottom: 90px;
  margin-left: 30px;
  margin-right: 30px;
}
</style>
